import { dispatcher } from 'dispatcher';
import { useEffect, useCallback } from 'react';

export const useLegacyGameLaunchHandler = () => {
    const handleLaunchGameClick = useCallback((event) => {
        const subject = event.target.closest('.fn-launch-game');

        if (!subject) {
            return;
        }

        const data = subject.dataset;
        const code = data.gameCode || data.gamecode || data.code;
        const mode = data.demo === '1' ? 0 : 1;
        const queryString = data.queryString || '';
        const source = subject?.closest('[data-launch-source]')?.dataset?.launchSource || 'page'; // @theme

        if (code) {
            dispatcher.dispatch('game:launch', { code, mode, queryString, source }); // @theme
        }
    }, []);

    useEffect(() => {
        document.body.addEventListener('click', handleLaunchGameClick);

        return () => {
            document.body.removeEventListener('click', handleLaunchGameClick);
        };
    }, [handleLaunchGameClick]);
};
